<div class="contents">
  <app-back-button></app-back-button>

  <div class="Grupo-main custom-modal-layout">
    <form class="background-white form-Grupo" [formGroup]="form" (ngSubmit)="save()">

      <div class="modal-header mb-3">
        <div class="icon">
          <img src="icons/plus-circle.svg" alt="Ícone adicionar" />
        </div>
        <span class="title">Criar Grupo</span>
      </div>

      <div class="p-fluid grid">
        <div class="field col-12 d-flex flex-column">
          <label for="nome">Nome</label>
          <input type="text" pInputText formControlName="nome" placeholder="Nome do usuário" class="w-100" />
        </div>
        <!--
        <div class="field col-12 d-flex flex-column">
          <label for="descricao">Descrição</label>
          <input type="text" pInputText formControlName="descricao" placeholder="Descrição" class="w-100" />
        </div>
        -->
      </div>

      <div *ngIf="groupRolesLoaded && !groupHasRoles" class="alert-info mt-3 mb-2 text-sm">
        Este grupo ainda não tem permissões associadas. Seleciona abaixo para adicionar.
      </div>

      <div class="roles-header">
        <div class="filter-field">
          <label for="filtrar" class="mr-1">Filtrar</label>
          <input id="filtrar" type="text" pInputText [formControl]="searchTermCtrl" placeholder="Filtre pela permissão"
            class="w-50" />
        </div>

        <div class="select-all">
          <button pButton type="button" class="p-button-sm"
            [label]="areAllSelected ? 'Desmarcar todas' : 'Marcar todas'" (click)="toggleSelectAll()">
          </button>
          <span class="roles-count text-sm text-secondary">
            Selecionadas: {{ totalSelected }} / {{ totalRoles }}
          </span>
        </div>
      </div>

      <div class="roles-list">
        <ng-container *ngIf="filteredRoles.length; else noRoles">
          <div class="roles-items">
            <div *ngFor="let role of filteredRoles; trackBy: trackByRole" class="field col-4">
              <div class="d-flex align-items-center">
                <p-checkbox [binary]="true" [ngModel]="isRoleSelected(role.id)"
                  (ngModelChange)="onRoleToggle(role.id, $event)" [ngModelOptions]="{ standalone: true }">
                </p-checkbox>
                <label class="ml-2">{{ role.name }}</label>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #noRoles>
          <p class="mt-3 text-muted">Nenhuma permissão encontrada.</p>
        </ng-template>
      </div>

      <div class="mt-4 d-flex justify-content-between align-items-center">
        <button pButton type="submit" label="Salvar Grupo"></button>
        <button pButton type="button" *ngIf="assignedRoles.length > 0" label="Remover Permissões" severity="danger" [raised]="true"
          (click)="showModalremoveRoles()"></button>
        <button pButton type="button" label="Pre-visualizar Grupo" severity="secondary" [raised]="true"
          (click)="showPreviewProfile = true"></button>
      </div>
    </form>
  </div>
</div>

<p-drawer [(visible)]="showPreviewProfile" header="Pre-visualizar Grupo" position="right" [style]="{ width: '30rem' }">
  <div class="preview-drawer">
    <div class="preview-info">
      <span>Nome</span>
      <h6>{{ previewNome }}</h6>
    </div>

    <!--
    <div class="preview-info">
      <span>Descrição</span>
      <h6>{{ previewDescricao }}</h6>
    </div>
    -->

    <p class="permitions">Permissões selecionadas</p>
    <ul class="selected-roles">
      <li *ngFor="let r of selectedRoles">● {{ r.description }}</li>
    </ul>
  </div>
</p-drawer>
<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>

<p-dialog [visible]="showModalRoles" [modal]="true" [style]="{ width: '50rem' }" [closable]="false"
  header="Remover Permissões">
  <ng-template pTemplate="header">
    <h3>Remover Permissões</h3>
  </ng-template>
  <div class="roles-list">
    <ng-container *ngIf="assignedRoles.length; else noRoles">
      <div class="p-fluid grid roles-items">
        <div *ngFor="let role of assignedRoles; trackBy: trackByRole" class="field col-3">
          <div class="d-flex align-items-center justify-content-between mb-2 w-100">
            <span>{{ role.description }}</span>
            <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text"
              (click)="confirmRemoveRole(role)" pTooltip="Remover permissão" tooltipPosition="top"></button>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #noRoles>
      <p class="mt-3 text-muted">Nenhuma permissão atribuída ao grupo.</p>
    </ng-template>
  </div>

  <div class="modal-footer d-flex justify-content-between align-items-center mt-5">
    <button pButton type="button" label="Cancelar" severity="secondary" (click)="showModalRoles = false"></button>
    <button pButton type="button" label="Confirmar Remoção" (click)="showModalRoles = false"></button>
  </div>
</p-dialog>
